import React, { useEffect } from "react";
import { Icon, Pagination, usePagination } from "ui";
import { CheckoutsTable } from "./checkouts-table";
import { useCheckouts } from "../api/get-checkouts";
import styles from "./checkouts.module.scss";

export const CheckoutList = () => {
  const {
    page,
    pageSize,
    pageCount,
    handlePageChange,
    handlePageCountChange,
    handlePageSizeChange,
  } = usePagination();
  const { data, isFetching, error, isFetched  } = useCheckouts({
    PageNumber: page,
    PageSize: pageSize,
  });
  useEffect(() => {
    if (isFetched && data) {
      handlePageCountChange(Math.ceil(data.totalRecord / data.pageSize));
    }
  }, [data, isFetched, handlePageCountChange]);
 
  return (
    <div className={styles.checkouts_container}>
      <div className={styles.title}>
        {<Icon type={"wallet"} style={{ fontSize: "22px" }} />}
        <h2>واریز بانکی</h2>
      </div>
      <div className={styles.table_container}>
        <CheckoutsTable
          page={page}
          pageSize={pageSize}
          error={error?.message}
          checkouts={data?.data}
          isLoading={isFetching}
        />
        <Pagination
          page={page}
          pageSize={pageSize}
          pageCount={pageCount}
          onPageChange={handlePageChange}
          onPageSizeChange={handlePageSizeChange}
          onPageCountChange={handlePageCountChange}
        />
      </div>
    </div>
  );
};
